import {
  resolveApiBaseUrl,
  resolveSocketOrigin,
  PRODUCTION_API_BASE_URL,
  PRODUCTION_API_ORIGIN,
} from '../shared/config/api';

export {
  resolveApiBaseUrl,
  resolveSocketOrigin,
  PRODUCTION_API_BASE_URL,
  PRODUCTION_API_ORIGIN,
};

export const API_BASE_URL = resolveApiBaseUrl();
